<template>
    <v-container>
        <div class="container-bg" style="margin-top: 1%; margin: auto">
            <v-overlay :value="loading" absolute opacity="0.85" class="overflow:hidden;">
                <v-progress-circular class="ma-3" indeterminate large color="secondary" />
            </v-overlay>
            <div class="container-fg">
                <div style="display: flex; flex-direction: row">
                    <img style="width: 130px; margin-bottom: 1%" src="../../../assets/logos/getac-logo.svg" />
                    <div class="text-h7 nav-font pl-3" style="margin-top: 1.3%">INVENTORY PROFILE</div>
                </div>
                <v-divider style="margin-bottom: 1%; border-color: gray" />
                <div>
                    <div style="display: flex; flex-direction: row">
                        <v-list-item-avatar tile size="150px">
                            <v-icon style="max-width: 100%; height: auto">{{ mdiAccountBox }}</v-icon>
                        </v-list-item-avatar>
                        <div style="display: flex; flex-direction: column">
                            <h1 style="font-size: 36px; letter-spacing: -0.08rem">
                                Profile Information
                                <v-btn dark outlined color="#db5120" x-small class="ml-5" @click="editInfo = true">
                                    Edit
                                </v-btn>
                            </h1>
                            <v-row>
                                <v-col cols="6" class="text-start">
                                    <div class="text-overline"> Contact Information</div>
                                    <v-list-item-subtitle class="mb-1">{{
                                        contact.shipping.company
                                    }}</v-list-item-subtitle>
                                    <v-list-item-subtitle class="mb-1">{{
                                        contact.shipping.firstName + ' ' + contact.shipping.lastName
                                    }}</v-list-item-subtitle>
                                    <v-list-item-subtitle class="mb-1">{{
                                        contact.shipping.email
                                    }}</v-list-item-subtitle>
                                    <v-list-item-subtitle class="mb-1">{{
                                        contact.shipping.phone
                                    }}</v-list-item-subtitle>
                                </v-col>
                                <v-col cols="6" class="text-start">
                                    <div class="text-overline"> Address Information</div>
                                    <v-list-item-subtitle class="mb-1">{{
                                        address.shipping.line1
                                    }}</v-list-item-subtitle>
                                    <v-list-item-subtitle
                                        v-if="address && address.shipping && address.shipping.line2"
                                        class="mb-1"
                                        >{{ address.shipping.line2 }}</v-list-item-subtitle
                                    >
                                    <v-list-item-subtitle
                                        v-if="address && address.shipping.city && address.shipping.state"
                                        class="mb-1"
                                        >{{
                                            address.shipping.city + ', ' + address.shipping.state
                                        }}</v-list-item-subtitle
                                    >
                                    <v-list-item-subtitle
                                        v-if="address && address.shipping.country && address.shipping.postalCode"
                                        class="mb-1"
                                        >{{
                                            address.shipping.country + ', ' + address.shipping.postalCode
                                        }}</v-list-item-subtitle
                                    >
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                    <v-divider class="mt-5" style="margin-bottom: 1%; border-color: gray" />
                </div>
                <v-divider style="margin-bottom: 1%; border-color: gray" />
                <div>
                    <div style="display: flex; flex-direction: row">
                        <v-list-item-avatar tile size="150px">
                            <v-icon style="max-width: 100%; height: auto">{{ mdiToolbox }}</v-icon>
                        </v-list-item-avatar>
                        <div style="display: flex; flex-direction: column">
                            <h1 style="font-size: 36px; letter-spacing: -0.08rem">
                                Profile Categories
                                <v-btn dark outlined color="#db5120" x-small class="ml-5" @click="seedStockView = true">
                                    Seed Stock
                                </v-btn>
                            </h1>
                            <v-row class="mt-3 pr-10">
                                <v-col v-for="(item, i) in partCategories" :key="i" cols="2" class="ml-2 pa-0">
                                    <v-chip
                                        :color="confirmedCategories.includes(item) ? 'success' : ''"
                                        style="width: 100%"
                                        label
                                        class="ml-2 ma-0"
                                        dark
                                        >{{ item }}</v-chip
                                    >
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                    <v-divider class="mt-10" style="margin-bottom: 1%; border-color: gray" />
                </div>
            </div>
            <v-dialog v-model="editInfo" width="750px">
                <confirm-info @confirmed="infoConfirmed" @cancel="editInfo = false"></confirm-info>
            </v-dialog>
            <v-dialog v-model="seedStockView" width="450px">
                <seed-stock
                    :confirmed-customer="{ contact: contact.shipping, address: address.shipping }"
                    :confirmed-categories="confirmedCategories"
                    @submitted="stockSubmitted($event)"
                    @errorSubmit="errorSubmit($event)"
                ></seed-stock>
            </v-dialog>
        </div>
        <v-snackbar v-model="snackbar">
            {{ snackbarMessage }}

            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" color="white" @click="snackbar = false"> Close </v-btn>
            </template>
        </v-snackbar>
    </v-container>
</template>

<script>
import gql from 'graphql-tag'
import { mdiAccountBox, mdiToolbox } from '@mdi/js'
import ConfirmInfo from '../../user_account/product_registration/confirm_info.vue'
import SeedStock from '../../user_account/product_registration/seed_stock.vue'

export default {
    name: 'SMInventoryProfile',
    components: { ConfirmInfo, SeedStock },
    apollo: {
        querySMCustomer: {
            query: gql`
                query QuerySMCustomer($customerId: String!) {
                    querySMCustomer(customerId: $customerId) {
                        shipping {
                            address {
                                APO
                                company
                                line1
                                line2
                                city
                                state
                                country
                                postalCode
                                international
                            }
                            contact {
                                firstName
                                lastName
                                fullName
                                email
                                phone
                                company
                                position
                            }
                        }
                        smConfirmed
                        confirmedCategories
                    }
                }
            `,
            skip() {
                return !this.$auth.user.org.branchId
            },
            variables() {
                return {
                    customerId: this.$auth.user.org.branchId
                }
            },
            update(data) {
                const customer = data.querySMCustomer
                if (customer && customer.confirmedCategories) {
                    this.confirmedCategories = customer.confirmedCategories
                }
                if (customer && customer.shipping) {
                    if (customer.shipping.contact) {
                        this.contact.shipping = {
                            company: customer.shipping.contact.company || ``,
                            firstName: customer.shipping.contact.firstName || ``,
                            lastName: customer.shipping.contact.lastName || ``,
                            email: customer.shipping.contact.email || ``,
                            phone: customer.shipping.contact.phone || ``,
                            phoneCountryCode: ``
                        }
                    }
                    if (customer.shipping.address) {
                        this.address.shipping = {
                            country: customer.shipping.address.country || ``,
                            line1: customer.shipping.address.line1 || ``,
                            line2: customer.shipping.address.line2 || ``,
                            city: customer.shipping.address.city || ``,
                            state: customer.shipping.address.state || ``,
                            postalCode: customer.shipping.address.postalCode || ``
                        }
                    }
                }
            }
        },
        querySMCustomerCategories: {
            query: gql`
                query Query($customerId: String!) {
                    querySMCustomerCategories(customerId: $customerId)
                }
            `,
            variables() {
                return {
                    customerId: this.$auth.user.org.branchId
                }
            },
            update(data) {
                this.partCategories = data.querySMCustomerCategories
                this.loading = false
            }
        }
    },
    data() {
        return {
            seedStockView: false,
            snackbar: false,
            snackbarMessage: ``,
            editInfo: false,
            mdiToolbox,
            loading: true,
            partCategories: [],
            confirmedCategories: [],
            contact: {
                billing: {
                    company: ``,
                    firstName: ``,
                    lastName: ``,
                    email: ``,
                    phone: ``,
                    phoneCountryCode: ``
                },
                shipping: {
                    company: ``,
                    firstName: ``,
                    lastName: ``,
                    email: ``,
                    phone: ``,
                    phoneCountryCode: ``
                }
            },
            address: {
                billing: {
                    line1: ``,
                    line2: ``,
                    city: ``,
                    state: ``,
                    postalCode: ``
                },
                shipping: {
                    line1: ``,
                    line2: ``,
                    city: ``,
                    state: ``,
                    postalCode: ``
                }
            },
            mdiAccountBox
        }
    },
    methods: {
        errorSubmit(error) {
            this.snackbar = true
            this.snackbarMessage = error
        },
        stockSubmitted(data) {
            this.seedStockView = !data.data.updateAccountOrganization.success
            this.snackbar = true
            this.snackbarMessage = !data.data.updateAccountOrganization.success
                ? data.data.updateAccountOrganization.error
                : 'Successfully submitted'
            this.confirmedCategories = data.data.confirmedCategories
        },
        infoConfirmed(customer) {
            const input = {
                address: customer.address,
                contact: {
                    company: customer.contact.company,
                    firstName: customer.contact.firstName,
                    lastName: customer.contact.lastName,
                    email: customer.contact.email,
                    phone: customer.contact.phone
                }
            }
            this.$apollo
                .mutate({
                    mutation: gql`
                        mutation UpdateAccountOrganization($input: AccountOrganizationInput!, $orgId: String!) {
                            updateAccountOrganization(input: $input, orgId: $orgId) {
                                complete
                                error
                                success
                                uid
                            }
                        }
                    `,
                    variables: {
                        input: input,
                        orgId: this.$auth.user.org.branchId
                    }
                })
                .then((data) => {
                    this.editInfo = !data.data.updateAccountOrganization.success
                    this.snackbar = true
                    this.snackbarMessage = !data.data.updateAccountOrganization.success
                        ? data.data.updateAccountOrganization.error
                        : 'Successfully updated'
                    this.$apollo.queries.querySMCustomer.refetch()
                })
                .catch((e) => {
                    this.snackbar = true
                    this.snackbarMessage = e
                })
        }
    }
}
</script>

<style scoped>
#parts-select {
    margin-right: 100px;
}
.product-card {
    margin: auto;
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    background-image: linear-gradient(155deg, rgba(90, 90, 90, 0.6), rgba(255, 255, 255, 0));
    border-radius: 10px;
    margin-bottom: 10px;
    border: 1px solid rgba(255, 255, 255, 0.3);
}
.product-card-bg {
    background: rgba(0, 0, 0, 0.349);
    border-radius: 16px;
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
}
#model-select-heading {
    font-size: 36px;
    line-height: 0.9;
    letter-spacing: -0.1rem;
    margin-left: 10px;
    position: fixed;
    left: 0;
    /* bottom: 0; */
    margin-bottom: 100px;
    color: white;
}
.heading-line-two {
    color: #db5120 !important;
}
</style>
